<template>
    <v-row align="center" class="mt-5 ml-3 mb-1">
        <v-col cols="auto" class="pr-0">
            <v-sheet 
            class="rounded-lg d-flex justify-center align-center" 
            height="60px"
            width="60px"
            :style="gradientStyle"
            >
                <v-icon color="white">{{ icon }}</v-icon>
            </v-sheet>
        </v-col>
        <v-col class="pl-0">
            <v-card-title class="text-h6 font-weight-regular accent--text">{{ title }}</v-card-title>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "card-header",
        props: {
            title: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: false,
                default: "assignment"
            },
            color: {
                type: String,
                required: false,
                default: "primary"
            },
            variant: {
                type: String,
                required: false,
                default: "gradient",
                validator: (value) => ["gradient", "fill"].includes(value)
            },
        },
        computed: {
            gradientStyle() {
                if (this.variant === "gradient") {
                    return {
                        background: `linear-gradient(135deg, ${this.getGradientColor(this.color)})`,
                        boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.1)" // 그림자 추가
                    };
                }
                return {
                    background: this.color,
                    boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.1)" // 기본 그림자 추가
                };
            }
        },
        methods: {
            getGradientColor(color) {
                const red = "#f44336";
                const pink = "#e91e63";
                const purple = "#9c27b0";
                const blue = "#2196f3";
                const green = "#4caf50";
                const yellow = "#fec60a";
                const orange = "#ff9800";
                const black = "#424242";


                const gradientColors = {
                    primary: `${orange}, #feb47b`,
                    blue: `${blue}, #6dd5ed`,  // 블루 계열
                    green: `${green}, #a8e063`, // 그린 계열
                    yellow: `${yellow}, #f2c94c`, // 옐로우 계열
                    red: `${red}, #ea384d`,  // 레드 계열
                    purple: `${purple}, #e100ff`,  // 퍼플 계열
                    pink: `${pink}, #ff7eb3`, // 핑크 계열
                    black: `${black}, #414345`,  // 블랙-그레이 계열
                };
                return gradientColors[color] || gradientColors.primary;
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>
